import { CheckCircle, Clock, PaperPlaneTilt, WarningCircle, XCircle, ClipboardText, Handshake } from "@phosphor-icons/react";

export const TIERS = [
  { v: "store", label: "Tienda" },
  { v: "marketplace", label: "Distribuidor" },
  { v: "reseller", label: "Reventa" },
  { v: "min", label: "Mínimo" },
  { v: "custom", label: "Personalizado" },
];

export const STATUS_META = {
  quote:         { label: "Cotización",   color: "#7E57C2", Icon: ClipboardText },
  quote_expired: { label: "Cotiz. vencida", color: "#FF7043", Icon: WarningCircle },
  accepted:      { label: "Aceptada",     color: "#00873D", Icon: Handshake },
  draft:         { label: "Borrador",     color: "#52525B", Icon: Clock },
  sent:          { label: "Enviada",      color: "#1E88E5", Icon: PaperPlaneTilt },
  overdue:       { label: "Vencida",      color: "#FFC000", Icon: WarningCircle },
  paid:          { label: "Pagada",       color: "#00873D", Icon: CheckCircle },
  canceled:      { label: "Cancelada",    color: "#E0000F", Icon: XCircle },
};

export const PAYMENT_FILTERS = [
  { v: "all",          label: "Todos los pagos",        color: "#52525B" },
  { v: "receivable",   label: "Por cobrar (con saldo)", color: "#E0000F" },
  { v: "no_payments",  label: "Sin abonos",             color: "#52525B" },
  { v: "partial",      label: "Con abonos parciales",   color: "#FFC000" },
  { v: "multi",        label: "Multi-pagos (2+)",       color: "#7E57C2" },
];

export const tierPrice = (p, t) =>
  t === "min" ? p.min_price :
  t === "reseller" ? p.reseller_price :
  t === "marketplace" ? p.marketplace_price :
  t === "store" ? p.store_price : 0;

export const fmt = (n, cur) =>
  `${cur === "USD" ? "$" : "MX$"}${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const toISO = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
export const fromISO = (s) => { const d = new Date(s + "T12:00:00"); return isNaN(d) ? new Date() : d; };
export const todayISO = () => toISO(new Date());
